import { Component, OnInit, Optional, Inject } from '@angular/core';
import { CampaignsService } from 'src/app/pages/campaign-module/campaigns/campaigns.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogService, LanguageService } from 'src/app/services';
import { environment } from "src/environments/environment";
import { MediaObserver } from '@angular/flex-layout';
import { finalize, catchError } from "rxjs/operators";
import { of as observableOf } from "rxjs";
import * as _ from "lodash";

@Component({
  selector: 'esc-coupon-generator',
  templateUrl: './coupon-generator.component.html',
  styleUrls: ['./coupon-generator.component.scss']
})
export class CouponGeneratorComponent implements OnInit {

  loading = {
    submit: false
  };

  couponDetails;
  pre_generated_max_qty;
  on_demand_max_qty;

  constructor(
    public media: MediaObserver,
    private dialogService: DialogService,
    private languageService: LanguageService,
    private campaignsService: CampaignsService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<CouponGeneratorComponent>
  ) { }

  ngOnInit() {
    // console.log(this.data)
    this.setMaxQuantity();
  }

  setMaxQuantity() {
    this.pre_generated_max_qty = _.get(this.data, 'campaign_distribution_data.pre_generated_max_qty') - _.get(this.data, 'campaign_distribution_data.pre_generated_qty');

    this.on_demand_max_qty = _.get(this.data, 'campaign_distribution_data.on_demand_max_qty') - _.get(this.data, 'campaign_distribution_data.on_demand_qty');
  }

  getCouponQty(eventData) {
    this.couponDetails = _.cloneDeep(eventData);
  }

  generateCoupon() {
    let loadingDialog = this.dialogService.loading();
    let obj = {
      data: [
        {
          distribution_id: _.get(this.data.campaign_distribution_data, 'distribution_id'),
          generation_type: _.get(this.couponDetails, 'generation_type'),
          quantity: parseInt(_.get(this.couponDetails, 'quantity'))
        }
      ]
    };
    
    this.campaignsService.generateCouponFromWizard(obj).pipe(
      finalize(() => {
        loadingDialog.close();
        return observableOf(null);
      }),
      catchError(err => {
        if (environment.showLogs) {
          console.log(err);
        }
        this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_ERROR_NETWORK_CONNECTION", {}));
        return observableOf(null);
      }))
    .subscribe(
      (res: any) => {
        if (environment.showLogs) {
          console.log(res);
        }
        if (_.get(res, 'success.count') > 0) {
          this.dialogRef.close("Sucess");
          this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_COUPON_GENERATE_SUCCESS", {}));
        }
      },
      err => {
        if (environment.showLogs) {
          console.log(err);
        }
        this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_ERROR_NETWORK_CONNECTION", {}));
      }
    );
  }
}
